import React, { useState, useEffect } from 'react'
import { TransitionGroup } from 'react-transition-group';
import { CardHeader, Card, CardBody } from "reactstrap";
import { VerticalTimeline } from "react-vertical-timeline-component";
import avatarMen from "../../../../../../assets/images/profile_placeholder_men.png";
import avatarWomen from "../../../../../../assets/images/profile_placeholder.png";
import { getAllSurveyReply, deleteOneReplyOfASurvey } from '../../../../../../actions/activities_reply_actions';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import Loader from "react-loaders";
import LoadingOverlay from 'react-loading-overlay-ts';
import SurveyView from '../../view/SurveyResponsesView'
import CreateExcerpt from '../../view/Excerpts/CreateExcerpt';
import Swal from 'sweetalert'

//quick surveys and project surveys stream
const ScreenerAnalytics = () => {

    const surveyState = useSelector(state => state.SurveyReply)
    const dispatch = useDispatch()
    const params = useParams()
    const [surveyReply, setSurveyReplies] = useState([])
    const [isLoading, setLoading] = useState(true)
    //const [loadMore, set_loadMore] = useState(false)

    const [isModalOpen, setModal] = useState(false)

    const [excerptData, setExcerptData] = useState({
        selectedString: '',
        note: '',
        activity: '',
        responseAuthor: ''
    })

    const resetData = () => {
        setExcerptData({
            selectedString: '',
            note: '',
            activity: '',
            responseAuthor: ''
        })
    }

    // Show Image inModal
    const showModal = (author, details) => {

        resetData()
        //setModal(!isModalOpen)

        setExcerptData(prevState => ({
            ...prevState,
            selectedString: window.getSelection().toString(),
            activityType: details.title,
            activityTitle: details.title,
            activity: params.activityid,
            responseAuthor: author
        }))

    }


    const getResponses = (page = 1, limit = 5, loadMore) => {

        dispatch(getAllSurveyReply({ page: page, limit: limit, activityId: params.activityid }))
            .then((response) => {
                const replies = response.payload.content.replies;



                let result = [];

                for (let i = 0; i < replies.length; i++) {
                    const reply = replies[i];

                    const singleReply = {
                        replies: [],
                        author: reply.author,
                        created_at: reply.created_at,
                        replyId: reply._id,
                        replyLoi: reply.loi
                    };


                    if (reply.questions && reply.questions.length != 0 && reply.pages && reply.pages.length === 0) {

                        // Execute the previous logic block when we have only questions field in database
                        const repliesAnswers = reply.questions;
                        for (let j = 0; j < reply.activity.survey.pages.length; j++) {
                            for (let k = 0; k < reply.activity.survey.pages[j].questions.length; k++) {
                                repliesAnswers.map(ans => {
                                    if (ans.questionId === reply.activity.survey.pages[j].questions[k]._id) {
                                        // saving question object, answer, and id
                                        singleReply.replies.push({
                                            ...reply.activity.survey.pages[j].questions[k],
                                            ...ans,
                                            _id: reply.activity.survey.pages[j].questions[k]._id
                                        });
                                    }
                                });
                            }
                        }
                    } else {



                        // new logic for questions and answers mismatch
                        for (let j = 0; j < reply.activity.survey.pages.length; j++) {
                            const page = reply.activity.survey.pages[j];

                            // Iterate through all questions on the current page in survey questionnaire
                            for (let k = 0; k < page.questions.length; k++) {
                                const question = page.questions[k];


                                // Find the corresponding answer from survey replies where IDs match
                                const answer = reply.pages[j].questions.find(ans => ans.questionId === question._id);


                                // Only push if matching answer is found
                                if (answer) {
                                    singleReply.replies.push({
                                        ...question,
                                        ...answer,
                                        _id: question._id
                                    });
                                }
                            }
                        }

                    }

                    if (singleReply !== undefined && singleReply !== null) {
                        result.push(singleReply);
                    }

                    //result.push(singleReply);

                    result = result.filter(item => item !== undefined && item !== null);





                }
                if (loadMore === true) {
                    setSurveyReplies(prevReplies => [...prevReplies, ...result]);


                }
                else {

                    setSurveyReplies(result);
                }
                setLoading(false)
            })


            .catch(err => {
                setLoading(false)
                // Swal({
                //     title: err.response ? err.response.data.name : "Error",
                //     text: err.response ? err.response.data.content : "Something went wrong",
                //     icon: 'error'
                // })
            })

    }

    useEffect(() => {
 //console.log("useEffect triggered");
        getResponses()

    }, [])

    const next = () => {
        let loadMore = true
        getResponses(surveyState.currentPage + 1, 5, loadMore)
    }

    // const deleteReply = (authorIdd, replyIdd, replyActivityIdd) => {

    //     const deleteReplyDetails = {
    //         authorId: authorIdd,
    //         replyId: replyIdd,
    //         replyActivityId: replyActivityIdd
    //     }

    //     dispatch(deleteOneReplyOfASurvey(deleteReplyDetails))
    //         .then(response => {

    //             if (response.payload.message === 'One Response deleted successfully') {
    //                 Swal({

    //                     text: "Response deleted",
    //                     icon: 'success'
    //                 })
    //                     .then(
    //                         setTimeout(() => {
    //                             window.location.reload()
    //                         }, 2000)

    //                     )
    //             }
    //             else if (response.payload.message === 'Unable to delete a response') {
    //                 Swal({

    //                     text: "Error in deleting response",
    //                     icon: 'error'
    //                 })
    //             }
    //         })
    //         .catch(err =>
    //             console.log('err')
    //         )
    // }
    return (
        <TransitionGroup component="div" transitionName="TabsAnimation" transitionAppear={true}
            transitionAppearTimeout={0} transitionEnter={false} transitionLeave={false}>

            <LoadingOverlay tag="div" active={isLoading}
                styles={{
                    overlay: (base) => ({
                        ...base,
                        background: "#fff",
                        opacity: 0.5,
                        // position: 'fixed',
                        // top: '2%'
                    }),
                }}
                spinner={
                    <Loader color="#6c757d" active type="ball-pulse" />
                }>

                <CreateExcerpt
                    data={excerptData} setData={setExcerptData}
                    isModalOpen={isModalOpen} showModal={() => setModal(false)}
                />

                {
                    surveyReply && surveyReply.length > 0 ?
                        surveyReply.map((reply, index) => {
                            return <>
                                <Card className="main-card mb-3">
                                    {/* Author */}
                                    <CardHeader className="text-capitalize" style={{ fontWeight: '600', fontSize: '0.9rem' }}>
                                        <div className='px-2'></div>

                                        <img src={reply && reply.author && reply.author.profileImage ? reply.author.profileImage : reply.author?.gender === "Female" ? avatarWomen
        : avatarMen} alt="profile" width={32} height={32} className="rounded-circle mr-2" />
                                        {reply && reply.author && reply.author.userName ? reply.author.userName : 'Respondent'}




                                        <div className='px-4'>{reply.replyLoi && reply.replyLoi}</div>
                                    </CardHeader>
                                    <CardBody>

                                        <VerticalTimeline layout="1-column"
                                            className="vertical-time-simple vertical-without-time">

                                            {

                                                reply && reply.replies.map((question, index) => {
                                                    return <div onClick={() => showModal(reply.author, question)}>

                                                        <SurveyView question={question} author={reply && reply.author && reply.author.userName} questionIndex={index} showVideos={false} />
                                                    </div>
                                                })
                                            }

                                        </VerticalTimeline>
                                    </CardBody>
                                </Card>

                            </>
                        }) :
                        <div className={"pb-2 ml-5"}>
                            <div className="row px-3">
                                <div className="col -12 mt-3 align-self-center text-center">
                                    <span style={{ color: '#999', fontSize: "0.85rem", fontWeight: '500', whiteSpace: 'pre-wrap', cursor: 'pointer' }}>No Responses Found</span>
                                </div>
                            </div>
                        </div>
                }

                {/* Load More Data */}
                {
                    surveyState.totalPages > 0 && surveyState.totalPages !== surveyState.currentPage &&
                    <div className={"pb-2 ml-5"}>
                        <div className="row px-3">
                            <div className="col -12 mt-3 align-self-center text-center" onClick={() => next()} >
                                <span style={{ color: '#999', fontSize: "0.85rem", fontWeight: '500', whiteSpace: 'pre-wrap', cursor: 'pointer' }}>Load More Responses</span>
                            </div>
                        </div>
                    </div>
                }

            </LoadingOverlay>

        </TransitionGroup >
    )
}

export default ScreenerAnalytics
